<template>
<div class="selector">
  <span>press f to move forward a page</span>
  <div class="images">
    <div v-for="{ image, liked } in images" :key="image"
         @click="toggleLike(image, liked)" :class="{ liked }">
      <img :src="`${host}/outputs/${image}`" />
      <div class="liked" :class="{ on: liked }"></div>
    </div>
  </div>
  <ul>
    <li v-for="i in pages" :key="`page-${i}`"
        :class="{ on: i === currentPage }"
        @click="goToPage(i)">
      {{ i }}
    </li>
  </ul>
</div>
</template>

<script>
import * as api from '@/api'

export default {
  name: 'SelectorView',
  components: {},
  props: {
    page: String
  },
  data() {
    return {
      pages: 0,
      images: []
    }
  },
  computed: {
    currentPage() {
      return this.page ? +this.page : 0
    },
    host() {
      const { hostname } = window.location
      if (hostname.match(/localhost/)) {
        return `http://${hostname}:8000`
      }
      return 'https://shell-patterns.llia.io/api'
    }
  },
  methods: {
    goToPage(page) {
      this.$router.push({ params: { page } })
    },
    async toggleLike(image, liked) {
      await api.put(`/patterns/like/${image}/${!liked}`)
      const index = this.images.findIndex(e => e.image === image)
      this.images[index] = { image, liked: !liked }
    }
  },
  async created() {
    const info = await api.get('/patterns/info')
    this.pages = info.pages
    api.get(`/patterns/page/${this.page}`)
      .then(images => { this.images = images })

    window.onkeydown = (event) => {
      if (event.key === 'f') {
        this.goToPage(this.currentPage + 1)
      }
    }

    this.$watch(
      () => this.$route.params,
      () => {
        console.log('change')
        api.get(`/patterns/page/${this.page}`)
          .then(images => { this.images = images })
      },
      { immediate: true }
    )
  }
}
</script>

<style lang="scss" scoped>
div.selector {
  width: 1100px;
  margin: 0 auto;
  text-align: center;
}

li {
  list-style: none;
  display: inline-block;
  margin: 0.25rem;
  padding: 0.25rem;
  background: #bbb;
  border-radius: 0.25rem;
  width: 1.25rem;
  font-size: 0.75rem;
  text-align: center;
  //border: 1px solid #ccc;

  &:hover {
    cursor: pointer;
  }

  &.on {
    background: #333;
    color: #fff;
  }
}

div.images {
  $width: 168px;
  $padding: 5px;

  margin: 0 auto;
  margin-top: 10px;
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
  width: calc(#{$width} * 5 + #{$padding} * 5 * 2);

  >div {
    padding: $padding;
    margin: 0;
    position: relative;
    display: inline-block;

    img {
      width: $width;
      height: $width;
      margin: 0;
      padding: 0;
      display: block;
    }

    &.liked {
      img {
        opacity: 0.1;
      }
    }
  }

  //$inset: 5px;
  //
  //div.liked {
  //  position: absolute;
  //  width: calc(#{$width});
  //  height: calc(#{$width});
  //  top: $inset;
  //  left: $inset;
  //
  //  &.on {
  //    //background: rgba(0, 0, 0, 0.8);
  //    //border: $inset solid #ff009a;
  //  }
  //}

}
</style>
